import api from "./apiConfig";

export const CREATE_POLL = async (answers, token) => {
	try {
		const response = await api.post("/satisfactionPoll", answers, token);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_POLLS = async () => {
	try {
		const response = await api.get("/satisfactionPoll");
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_POLLS_BY_ACCOUNTANT = async (id) => {
	try {
		const response = await api.get(`/satisfactionPollByAccountant/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_POLLS_BY_ENTERPRISE = async (id) => {
	try {
		const response = await api.get(`/satisfactionPollByClient/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};